import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=7702aff0&scoped=true&"
import script from "./topic.vue?vue&type=script&lang=ts&"
export * from "./topic.vue?vue&type=script&lang=ts&"
import style0 from "./topic.vue?vue&type=style&index=0&id=7702aff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7702aff0",
  null
  
)

export default component.exports